import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/ticket-outline-blue.png'
import _imports_1 from '@/assets/img/icon/note-outline-white.png'
import _imports_2 from '@/assets/img/icon/info-fill-blue.png'
import _imports_3 from '@/assets/img/icon/eye-background-blue.svg'
import _imports_4 from '@/assets/img/icon/delete-box-red.svg'


const _hoisted_1 = { class: "master-new-form" }
const _hoisted_2 = { class: "md:flex items-center justify-between order-bottom-white-darken-3 pb-3" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "X"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Data Mandoran", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "list"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString('Riwayat Transaksi'))
const _hoisted_8 = { class: "mt-32px" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "font-semibold text-sm text-gray-800 block mb-2"
}, "Nama Mandoran", -1)
const _hoisted_11 = { class: "border-bottom-white-darken-3" }
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "font-semibold text-sm text-gray-800 block mb-2"
}, "No Telepon", -1)
const _hoisted_14 = { class: "border-bottom-white-darken-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "font-semibold text-sm text-gray-800 block mb-2"
}, "Email", -1)
const _hoisted_16 = { class: "border-bottom-white-darken-3" }
const _hoisted_17 = { class: "mt-20px" }
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_19 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "font-semibold text-sm text-gray-800 block mb-2"
}, "Tipe Mandoran", -1)
const _hoisted_21 = { class: "border-bottom-white-darken-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "font-semibold text-sm text-gray-800 block mb-2"
}, "Tunjangan", -1)
const _hoisted_23 = { class: "border-bottom-white-darken-3 flex items-center justify-between" }
const _hoisted_24 = { class: "flex items-center gap-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Rp.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, /*#__PURE__*/_toDisplayString('/ Bulan'), -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "nfc",
  class: "font-semibold text-sm text-gray-800 block mb-2"
}, "Nomor NFC Tag", -1)
const _hoisted_28 = { class: "border-bottom-white-darken-3" }
const _hoisted_29 = { class: "mt-32px" }
const _hoisted_30 = { class: "border-grey-3 rounded-lg p-4 md:flex gap-4" }
const _hoisted_31 = { class: "w-full md:w-1/3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg mb-11px" }, "Komisi Mandoran", -1)
const _hoisted_33 = { class: "border-primary background-blue-4 p-4 rounded-lg flex items-top gap-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "X",
  style: {"height":"16px"}
}, null, -1)
const _hoisted_35 = { class: "text-primary text-sm" }
const _hoisted_36 = { class: "w-full md:w-2/3" }
const _hoisted_37 = { class: "w-4/5" }
const _hoisted_38 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah Komisi'), -1)
const _hoisted_43 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}
const _hoisted_44 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Simpan")

import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import Card from 'primevue/card'
import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Button from 'primevue/button'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import apiUseCase from '@/usecase/apiUseCase'
import { Field, useFieldArray, useForm } from 'vee-validate'
import * as Yup from 'yup'
import numberFormat from '@/utils/helpers/numberFormat'

type CommissionOption = Record<string, any>
type CommissionField = {
  value: CommissionOption | null
  isNew: boolean
  assignmentId?: string
  originalCommissionId?: string
}
type CommissionFormValues = {
  commissionListField: CommissionField[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const employeeEndpoint = 'talent/v1/employees'
const employmentEndpoint = 'talent/v1/employments'
const salesAgentCommissionEndpoint = 'management/v2/salesAgentCommissions'
const salesAgentCommissionAssignmentEndpoint = 'management/v2/salesAgentCommissionAssignments'
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const store = useStore()
const router = useRouter()
const route = useRoute()
const mandoranId = ref<string>()
const mandoranDataDetail = ref(null) as any
const mandoranSalary = ref(null) as any
const commissionSchema = Yup.object({
  commissionListField: Yup.array()
    .min(1, 'Minimal harus memilih 1 komisi')
    .test('unique-commission', 'Komisi tidak boleh dipilih lebih dari sekali', (fields) => {
      if (!fields) return true

      const commissionIds = fields
        .map((commissionField: any) => {
          const value = commissionField?.value
          return value?.Id || value?.SalesAgentCommissionId || value?.id
        })
        .filter(Boolean)

      return new Set(commissionIds).size === commissionIds.length
    })
    .of(
      Yup.object({
        value: Yup.object().nullable().required('Komisi wajib diisi.')
      })
    )
})

const { errors, handleSubmit, setFieldError, setValues, submitCount, values } = useForm<CommissionFormValues>({
  initialValues: {
    commissionListField: [{ value: null, isNew: true }]
  },
  validationSchema: commissionSchema
})
const { fields: commissionListField, push, remove } = useFieldArray('commissionListField')
const getCommissionId = (commissionField: CommissionField) => (
  commissionField.value?.Id
  || commissionField.value?.SalesAgentCommissionId
  || commissionField.value?.id
)
const commissionListError = computed(() => {
  if (errors.value.commissionListField) {
    return errors.value.commissionListField
  }

  if (submitCount.value > 0 && commissionListField.value.length === 0) {
    return 'Minimal harus memilih 1 komisi'
  }

  return ''
})

const deleteCommissionAct = async (id: string, manageLoading = true) => {
  if (manageLoading) store.dispatch('showLoading')
  try {
    const response = await apiUseCase.delete(`${salesAgentCommissionAssignmentEndpoint}`, id)
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        summary: 'Komisi berhasil dihapus',
        group: 'bc',
        closable: false,
        life: 3000
      })
      return true
    }

    $toast.add({
      severity: 'error',
      summary: 'Komisi gagal dihapus',
      detail: message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  } catch (error) {
    console.error('Error deleting mandoran commission:', error)
    $toast.add({
      severity: 'error',
      summary: 'Komisi gagal dihapus',
      detail: 'Terjadi kesalahan saat menghapus komisi.',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } finally {
    if (manageLoading) store.dispatch('hideLoading')
  }

  return false
}

const onSubmit = handleSubmit(async (dataValues) => {
  store.dispatch('showLoading')
  // eslint-disable-next-line no-use-before-define
  const isCommissionCombinationValid = await validateCommissionCombinations(dataValues.commissionListField)
  store.dispatch('hideLoading')

  if (!isCommissionCombinationValid) return

  const payload = dataValues.commissionListField
    .filter((commissionField) => {
      const commissionId = getCommissionId(commissionField)
      return commissionField.isNew || Boolean(
        commissionField.assignmentId && commissionId !== commissionField.originalCommissionId
      )
    })
    .map((commissionField) => ({
      EmployeeId: mandoranId.value,
      SalesAgentCommissionId: getCommissionId(commissionField)
    }))

  store.dispatch('showLoading')
  try {
    const changedCommissions = dataValues.commissionListField.filter(
      (commissionField): commissionField is CommissionField & { assignmentId: string } => {
        const commissionId = getCommissionId(commissionField)
        return Boolean(commissionField.assignmentId && commissionId !== commissionField.originalCommissionId)
      }
    )
    const deleteResults = await Promise.all(
      changedCommissions.map((commissionField) => deleteCommissionAct(commissionField.assignmentId, false))
    )
    changedCommissions.forEach((commissionField, index) => {
      if (!deleteResults[index]) return

      const formField = values.commissionListField.find(
        (currentField) => currentField.assignmentId === commissionField.assignmentId
      )
      if (formField) {
        formField.assignmentId = undefined
        formField.isNew = true
      }
    })
    if (deleteResults.some((isDeleted) => !isDeleted)) return

    const response = await apiUseCase.postWithNoId(
      `${salesAgentCommissionAssignmentEndpoint}/bulk`,
      payload
    )

    if (response.error) {
      // throw new Error(response.message || 'Gagal menyimpan komisi mandoran')
      $toast.add({
        severity: 'error',
        summary: 'Komisi gagal disimpan',
        detail: response.message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      $toast.add({
        severity: 'success',
        summary: 'Mandoran berhasil diupdate',
        detail: `Data mandoran ${mandoranDataDetail.value?.fullName ?? '-'} berhasil diupdate.`,
        group: 'bc',
        closable: false,
        life: 3000
      })
      // eslint-disable-next-line no-use-before-define
      toPrevPage()
    }
  } catch (error) {
    console.error('Error saving mandoran commission:', error)
  } finally {
    store.dispatch('hideLoading')
  }
})

const getMandoranSalary = async (employmentId: string) => {
  // Fetch mandoran salary
  store.dispatch('showLoading')
  await apiOpenUseCase.get(`${employmentEndpoint}/${employmentId}`).then((res) => {
    console.log('Data mandoran salary:', res)
    mandoranSalary.value = res.result.salary?.baseSalary ?? null
  }).catch((err) => {
    console.error('Error fetching data mandoran salary:', err)
  })
  store.dispatch('hideLoading')
}

const getDataDetailMandoran = async () => {
  // Fetch data detail mandoran
  store.dispatch('showLoading')
  await apiOpenUseCase.get(`${employeeEndpoint}/${mandoranId.value}`).then((res) => {
    console.log('Data detail mandoran:', res)
    mandoranDataDetail.value = res.result
  }).catch((err) => {
    console.error('Error fetching data detail mandoran:', err)
  })
  store.dispatch('hideLoading')
}

const addCommission = () => {
  push({ value: null, isNew: true })
}

const removeCommission = async (index: number, field: any) => {
  const commissionField = values.commissionListField[index] || field

  const commissionValue = commissionField?.value?.value || commissionField?.value
  const isNew = commissionField?.isNew ?? commissionValue?.isNew

  if (!commissionField || isNew) {
    remove(index)
    return
  }

  const commissionId = commissionField?.assignmentId || commissionValue?.assignmentId
  if (commissionId && await deleteCommissionAct(commissionId)) {
    remove(index)
  }
}

const getCommissionDetail = async (id: string) => {
  const response = await apiUseCase.get(`${salesAgentCommissionEndpoint}/${id}`)
  if (response.error) return null

  return response.result?.Data || response.result || null
}

const validateCommissionCombinations = async (commissionFields: any[]) => {
  commissionFields.forEach((_, index) => setFieldError(`commissionListField[${index}].value`, undefined))

  const details = await Promise.all(
    commissionFields.map((commissionField) => {
      const commissionId = commissionField?.value?.Id || commissionField?.value?.SalesAgentCommissionId || commissionField?.value?.id
      return commissionId ? getCommissionDetail(commissionId) : null
    })
  )

  if (details.some((detail) => !detail)) {
    $toast.add({
      severity: 'error',
      summary: 'Validasi komisi gagal',
      detail: 'Detail komisi tidak dapat diperiksa. Silakan coba lagi.',
      group: 'bc',
      closable: false,
      life: 3000
    })
    return false
  }

  const combinationIndexes = new Map<string, number[]>()
  details.forEach((detail, index) => {
    if (!detail?.StationId || !detail?.ClassId) return

    const combination = `${detail.StationId}-${detail.ClassId}`
    const indexes = combinationIndexes.get(combination) || []
    indexes.push(index)
    combinationIndexes.set(combination, indexes)
  })

  let isValid = true
  combinationIndexes.forEach((indexes) => {
    if (indexes.length < 2) return

    isValid = false
    indexes.forEach((index) => {
      setFieldError(
        `commissionListField[${index}].value`,
        'Komisi dengan Terminal Asal dan Kelas yang sama sudah dipilih.'
      )
    })
  })

  return isValid
}

const getMandoranCommission = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${salesAgentCommissionAssignmentEndpoint}?employeeId=${mandoranId.value}`).then((response) => {
    const { result, error } = response
    if (!error) {
      // eslint-disable-next-line no-nested-ternary
      const commissions = Array.isArray(result) ? result : result ? [result] : []
      setValues({
        commissionListField: commissions.map((commission: any) => ({
          value: {
            label: commission.SalesAgentCommissionName,
            Name: commission.SalesAgentCommissionName,
            Id: commission.SalesAgentCommissionId
          },
          isNew: false,
          assignmentId: commission.Id,
          originalCommissionId: commission.SalesAgentCommissionId
        }))
      })
    }
  })
  store.dispatch('hideLoading')
}

const toTransactionLogPage = () => {
  console.log('toLogPage')
  // const encryptedId = encryptDecriptMethods.encrypt(mandoranId)
  router.push({
    name: 'master-mandoran-transaction-history',
    params: {
      id: route.params.id
    }
  })
}

const toCommissionDetailPage = (id: any) => {
  console.log('id', id)
  if (!id) return

  const encryptedId = encryptDecriptMethods.encrypt(id)
  const newRoute = router.resolve({
    name: 'master-mandoran-commission-detail',
    params: {
      id: encryptedId
    }
  })

  window.open(newRoute.href, '_blank')
}

const setBreadcrumb = () => {
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Mandoran',
      routeName: 'master-mandoran'
    },
    {
      title: mandoranDataDetail.value?.fullName ?? '-',
      routeName: 'master-mandoran-form',
      params: { id: route.params.id }
    }
  ])
}

const toPrevPage = () => {
  router.push({
    name: 'master-mandoran',
  })
}

onMounted(async () => {
  // console.log('Route params:', route.params.id)
  // console.log('Encrypted Mandoran ID:', encryptDecriptMethods.decrypt(route.params.id))
  mandoranId.value = encryptDecriptMethods.decrypt(route.params.id)
  // console.log('Decrypted Mandoran ID:', mandoranId.value)
  await getDataDetailMandoran()
  setBreadcrumb()

  if (mandoranId.value) {
    await getMandoranCommission()
  }

  const employmentId = mandoranDataDetail.value?.employments?.[mandoranDataDetail.value?.employments.length - 1]?.id
  if (employmentId) {
    await getMandoranSalary(employmentId)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
      class: "form-container"
    }, [
      _createVNode(_unref(Card), { class: "card-no-shadow" }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", {
                class: _normalizeClass(_unref(mandoranDataDetail)?.employments[_unref(mandoranDataDetail)?.employments.length - 1]?.isActive ? 'chip-green-outline-lite' : 'chip-grey-outline-lite')
              }, _toDisplayString(_unref(mandoranDataDetail)?.employments[_unref(mandoranDataDetail)?.employments.length - 1]?.isActive ? 'Aktif' : 'Nonaktif'), 3)
            ]),
            _createVNode(_unref(Button), {
              type: "button",
              class: "btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toTransactionLogPage()))
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(mandoranDataDetail)?.fullName ?? '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(mandoranDataDetail)?.phoneNumber ?? '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(mandoranDataDetail)?.email ?? '-'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(mandoranDataDetail)?.employments[0]?.employmentTypeName ?? '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", null, _toDisplayString(_unref(mandoranSalary) ? _unref(numberFormat)(_unref(mandoranSalary)) : '-'), 1)
                    ]),
                    _hoisted_26
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(mandoranDataDetail)?.nfcCardIdentifier ?? '-'), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, _toDisplayString('Komisi yang akan diterima oleh Mandoran. Untuk mengubah data komisi, silakan ubah melalaui menu Master Komisi Mandoran.'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commissionListField), (commissionField, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex items-top gap-4 mt-3 overflow-x-auto md:overflow-x-visible",
                    id: "commissionListField"
                  }, [
                    _createVNode(_unref(Field), {
                      name: `commissionListField[${index}].value`
                    }, {
                      default: _withCtx(({ value, handleChange, errorMessage }) => [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(SelectAsync, {
                            endpoint: salesAgentCommissionEndpoint,
                            classname: "custom-select w-full",
                            inputId: `commission-${index}`,
                            fieldLabel: (v) => `${v.Name}`,
                            searchFields: ['Name'],
                            placeholder: 'Pilih Komisi Mandoran',
                            modelValue: value,
                            "onUpdate:modelValue": handleChange,
                            searchCustom: [['isActive', '=', 'true']]
                          }, null, 8, ["inputId", "fieldLabel", "modelValue", "onUpdate:modelValue"]),
                          errorMessage
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "detail",
                          class: "cursor-pointer",
                          onClick: ($event: any) => (toCommissionDetailPage(value?.Id || value?.SalesAgentCommissionId || value?.id))
                        }, null, 8, _hoisted_39)
                      ]),
                      _: 2
                    }, 1032, ["name"]),
                    _createElementVNode("img", {
                      src: _imports_4,
                      alt: "delete",
                      onClick: ($event: any) => (removeCommission(index, commissionField)),
                      class: "cursor-pointer"
                    }, null, 8, _hoisted_40)
                  ]))
                }), 128)),
                _createVNode(_unref(Button), {
                  type: "button",
                  class: "flex gap-2 extra-submit-button mt-4",
                  id: "addCommissionButton",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (addCommission())),
                  outlined: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _unref(icon).svg.plusBlueEva
                    }, null, 8, _hoisted_41),
                    _hoisted_42
                  ]),
                  _: 1
                }),
                (_unref(commissionListError))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(commissionListError)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_unref(Button), {
              type: "button",
              class: "btn-back",
              onClick: toPrevPage
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 32)
  ]))
}
}

})